


















import { SfLoader, SfHeading } from '@storefront-ui/vue';
import {
  defineComponent,
  ref,
  useFetch,
  useContext,
  onMounted,
} from '@nuxtjs/composition-api';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useContent } from '~/composables';
import type { CmsPage } from '~/modules/GraphQL/types';
import { usePageStore } from '~/stores/page';
import HTMLContent from '~/components/HTMLContent.vue';
import { useRouter } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CmsPage',
  components: {
    HTMLContent,
    SfLoader,
    SfHeading,
  },
  props: {
    routerDataRes: {
      type: Object,
      default: {}
    },
  },
  setup({ routerDataRes }) {
    const { routeData } = usePageStore();
    const { addTags } = useCache();
    const { error: nuxtError } = useContext();
    const {
      loadPage,
      loading,
      error,
    } = useContent();
    const router = useRouter();

    const page = ref<CmsPage | null>(null);

    const handleLinkClick = (event) => {
      const anchor = event.target.closest('a');
      if (anchor) {
        event.preventDefault();
        const href = anchor.getAttribute('href');
        if (href) {
          router.push(href);
        }
      }
    };
    const handleLinkClickscroll = (event) => {
      const anchor = event.target.closest('a');
      if (anchor) {
        event.preventDefault();
        const href = anchor.getAttribute('href');
        if (href && href.startsWith('#')) {
          const id = href.replace('#', '');
          const targetElement = document.getElementById(id);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          } else {
            console.error(`Target element with id ${id} not found`);
          }
        } else if (href && href.startsWith('mailto:')) {
          window.location.href = href;
        } else if (href && href.startsWith('tel:')) {
          window.location.href = href;
        } else {
          router.push(href);
        }
      }
    };
    useFetch(async () => {
      page.value = await loadPage({ identifier: (routeData != null && routeData.identifier)? routeData.identifier : routerDataRes.identifier });

      if (error?.value?.page || !page.value) nuxtError({ statusCode: 404 });

      addTags([{ prefix: CacheTagPrefix.View, value: (routeData != null && routeData.identifier)? routeData.identifier : routerDataRes.identifier }]);
    });
    return {
      page,
      handleLinkClick,
      handleLinkClickscroll,
      loading,
    };
  },
  head() {
    return getMetaInfo(this.page);
  },
});
